import { api } from "./apiService";
import { BackendAPI } from "../config/api.paths";

/**
 * Test Plan Service
 * Handles all API calls for Test Plan management.
 */
export const testPlanService = {
  list: async (projectId, filters = {}) => {
    const response = await api.post(BackendAPI.testplans.list(), {
      project_id: projectId,
      ...filters,
    });
    return response;
  },

  get: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.get(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  create: async (payload) => {
    const response = await api.post(BackendAPI.testplans.create(), payload);
    return response;
  },

  update: async (id, projectId, payload) => {
    const response = await api.post(BackendAPI.testplans.update(), {
      id,
      project_id: projectId,
      ...payload,
    });
    return response;
  },

  archive: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.archive(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  restore: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.restore(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  complete: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.complete(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  delete: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.delete(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  linkRun: async (id, projectId, testRunId) => {
    const response = await api.post(BackendAPI.testplans.linkRun(), {
      id,
      project_id: projectId,
      testRunId,
    });
    return response;
  },

  createRunFromPlan: async (id, projectId, runName) => {
    const response = await api.post(BackendAPI.testplans.createRun(), {
      id,
      project_id: projectId,
      name: runName,
    });
    return response;
  },

  getProgress: async (id, projectId) => {
    const response = await api.post(BackendAPI.testplans.progress(), {
      id,
      project_id: projectId,
    });
    return response;
  },

  bulkArchive: async (ids, projectId) => {
    const response = await api.post(BackendAPI.testplans.bulkArchive(), {
      ids,
      project_id: projectId,
    });
    return response;
  },

  bulkRestore: async (ids, projectId) => {
    const response = await api.post(BackendAPI.testplans.bulkRestore(), {
      ids,
      project_id: projectId,
    });
    return response;
  },

  bulkComplete: async (ids, projectId) => {
    const response = await api.post(BackendAPI.testplans.bulkComplete(), {
      ids,
      project_id: projectId,
    });
    return response;
  },

  bulkDelete: async (ids, projectId) => {
    const response = await api.post(BackendAPI.testplans.bulkDelete(), {
      ids,
      project_id: projectId,
    });
    return response;
  },
};
